import React from "react";

export default (props) => {
  const { value, style } = props;

  return <div style={style} dangerouslySetInnerHTML={{ __html: value }} />;
}
